import React, { useCallback } from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import { MainObjectiveForm } from "../../components/MainObjectiveForm";
import { PersonalObjective } from "../../types";
import { isMobile } from "react-device-detect";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  personalObjective?: PersonalObjective | null;
  onSubmit: (data: any) => any;
};

export const MainObjectiveModal: React.FC<Props> = observer(
  ({ isOpen, onClose, personalObjective, onSubmit }) => {
    const { t } = useTranslation();

    const handleSubmit = useCallback(
      async (data: any) => {
        onSubmit(data);
      },
      [onSubmit]
    );

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={isMobile ? "xs" : "2xl"}
        // width={isMobile ? "90%" : ""}
        // size={{ base: "sm", lg: "xl" }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {personalObjective
              ? t("screens.client.personalObjectiveModal.typeEdit")
              : t("screens.client.personalObjectiveModal.typeNew")}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <MainObjectiveForm
              onSubmit={handleSubmit}
              personalObjective={personalObjective}
              onCancel={onClose}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  }
);
